export const ADDRESS_FINDER_ANSWER_MAP = {
  findProperty: "FindProperty",
  insuredAddressPostCode: "InsuredAddressPostCode",
  insuredAddressStreet: "InsuredAddressStreet",
  insuredAddressDistrict: "InsuredAddressDistrict",
  insuredAddressTown: "InsuredAddressTown",
  insuredAddressCounty: "InsuredAddressCounty",
};

export const ADDRESS_FINDER_MANUALLY_FORM = {
  findProperty: { Value: "" },
  postCode: { Value: "" },
  street: { Value: "" },
  district: { Value: "" },
  town: { Value: "" },
  county: { Value: "" },
};

export const PROPERTY_DETAILS_ANSWER_MAP = {
  propertyType: "PropertyType",
  buildYear: "BuildYear",
  numberOfBedrooms: "NumberOfBedrooms",
  numberOfBathrooms: "NumberOfBathrooms",
  wallConstruction: "WallConstruction",
  roofConstruction: "RoofConstruction",
};

export const PROPERTY_DETAILS_INTERFACE_KEY = [
  "PropertyType",
  "BuildYear",
  "NumberOfBedrooms",
  "NumberOfBathrooms",
  "WallConstruction",
  "RoofConstruction",
];

export const LIST_ADDRESS_MANUALLY_INTERFACE_KEY = [
  "InsuredAddressStreet",
  "InsuredAddressTown",
  "InsuredAddressCounty",
  "InsuredAddressPostCode",
  "InsuredAddressDistrict",
];

export const LL_COVER_DETAILS_AND_ELIGIBILITY_INTERFACE_KEYS = [
  "AccidentalDamageBuildings",
  "AccidentalDamageContents",
  "ExcessBuildings",
  "ExcessContents",
  "LandlordContentsLevel",
  "LandlordsEmergency",
  "RentGuarantee",
  "LegalExpenses",
  "Tenants18OrOver",
  "TenancyAgreement",
  "TenantCreditCheck",
  "FirstMonthRentPaid",
  "PreGrantNoticesIssued",
];

export const CUSTOMISE_COVER_INTERFACE_KEYS = [
  "HomeEmergency",
  "LegalExpenses",
  "BuildingsCoverLevel",
  "ExcessBuildings",
  "ContentsCoverLevel",
  "ExcessContents",
  "PersonalPossessionsToSpecify",
  "PPItemType",
  "PPItemDescription",
  "PPItemValue",
  "PersonalPossessionsTotalAmount",
  "SpecifiedItemDescription",
  "SpecifiedItemValue",
  "AccidentalDamageContents",
  "ContentsItemsToSpecify",
  "SpecifiedItemType",
  "SpecifiedItemDescription",
  "SpecifiedItemValue",
  "PersonalPossessionsOver2500",
];

export const PROPERTY_DETAILS_FORM = {
  windowLocksFitted: { Value: "", InterfaceKey: "" },
  alarmType: { Value: "", InterfaceKey: "" },
  unoccupiedNinetyDays: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWork: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWorkValue: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWorkJctContract: { Value: "", InterfaceKey: "" },
  studentTenants: { Value: "", InterfaceKey: "" },
  dssTenants: { Value: "", InterfaceKey: "" },
  noClaimsBuildings: { Value: "", InterfaceKey: "" },
  noClaimsContents: { Value: "", InterfaceKey: "" },
  findProperty: { Value: "", InterfaceKey: "" },
  propertyStatus: { Value: "", InterfaceKey: "" },
  numberOfAdults: { Value: "", InterfaceKey: "" },
  numberOfChildren: { Value: "", InterfaceKey: "" },
  residentialStatus: { Value: "", InterfaceKey: "" },
  ownershipProperty: { Value: "", InterfaceKey: "" },
  unapprovedMortgageApplication: { Value: "", InterfaceKey: "" },
};

export const COVER_DETAILS_FORM = {
  accidentalDamageBuildings: { Value: "", InterfaceKey: "" },
  excessBuildings: { Value: "", InterfaceKey: "" },
  landlordContentsLevel: { Value: "", InterfaceKey: "" },
  excessContents: { Value: "", InterfaceKey: "" },
  accidentalDamageContents: { Value: "", InterfaceKey: "" },
  rentGuarantee: { Value: "", InterfaceKey: "" },
  legalExpenses: { Value: "", InterfaceKey: "" },
  landlordsEmergency: { Value: "", InterfaceKey: "" },
  tenants18OrOver: { Value: "", InterfaceKey: "" },
  tenancyAgreement: { Value: "", InterfaceKey: "" },
  tenantCreditCheck: { Value: "", InterfaceKey: "" },
  firstMonthRentPaid: { Value: "", InterfaceKey: "" },
  preGrantNoticesIssued: { Value: "", InterfaceKey: "" },
};

export const ADDRESS_DETAILS_FORM = {
  findProperty: { Value: "", InterfaceKey: "" },
  propertyType: { Value: "", InterfaceKey: "" },
  buildYear: { Value: "", InterfaceKey: "" },
  numberOfBedrooms: { Value: "", InterfaceKey: "" },
  numberOfBathrooms: { Value: "", InterfaceKey: "" },
  wallConstruction: { Value: "", InterfaceKey: "" },
  roofConstruction: { Value: "", InterfaceKey: "" },
  windowLocksFitted: { Value: "", InterfaceKey: "" },
  alarmType: { Value: "", InterfaceKey: "" },
  unoccupiedNinetyDays: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWork: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWorkValue: { Value: "", InterfaceKey: "" },
  nonRoutineBuildingWorkJctContract: { Value: "", InterfaceKey: "" },
  studentTenants: { Value: "", InterfaceKey: "" },
  dssTenants: { Value: "", InterfaceKey: "" },
  noClaimsBuildings: { Value: "", InterfaceKey: "" },
  noClaimsContents: { Value: "", InterfaceKey: "" },
};

export const YOUR_APPLICATION_FORM = {
  policyStartDate: { Value: "", InterfaceKey: "" },
  documentDeliveryPreference: { Value: "", InterfaceKey: "" },
  applicant1TelNo: { Value: "", InterfaceKey: "" },
  applicant1EmailAddress: { Value: "", InterfaceKey: "" },
  applicant2TelNo: { Value: "", InterfaceKey: "" },
  applicant2EmailAddress: { Value: "", InterfaceKey: "" },
  useMortgageInformation: { Value: "", InterfaceKey: "" },
  mortgageLender: { Value: "", InterfaceKey: "" },
  mortgageStartDate: { Value: "", InterfaceKey: "" },
  useSolicitorInformation: { Value: "", InterfaceKey: "" },
  solicitorName: { Value: "", InterfaceKey: "" },
  solicitorEmailAddress: { Value: "", InterfaceKey: "" },
  emailAcceptToSolicitor: { Value: "", InterfaceKey: "" },
  emailNotificationToSolicitor: { Value: "", InterfaceKey: "" },
  additionalInfo: { Value: "", InterfaceKey: "" },
};
